import React, { useEffect, useRef, useState } from 'react'
import './ImportDocumentsPopUp.css'
import { CustomerCardModel } from '../../models/CustomerCardModel';
import { set } from 'lodash';

const ImportDocumentsPopUp = () => {

    const customerCardModel = useRef(new CustomerCardModel()).current;

    const [customersList, setCustomersList] = useState<any[]>([]);
    const [customerChosen, setCustomerChosen] = useState<string>('');
    const [customerSearch, setCustomerSearch] = useState<string>('');
    const [isCustomerListOpen, setIsCustomerListOpen] = useState(false);

    const [documentsList, setDocumentsList] = useState<any[]>([]);

    const [selectedDocuments, setSelectedDocuments] = useState<string[]>([]);

    const filter = {
        customerId: customerChosen,
    };

    const filteredCustomers = customersList.filter((client) =>
        client.label.toLowerCase().includes(customerSearch.toLowerCase())
    );

    useEffect(() => {

        const allCustomer = sessionStorage.getItem('allCustomers');
        if (allCustomer) {
            const customers = JSON.parse(allCustomer);
            setCustomersList(customers);
        }
        init();

    }, [])

    const init = async () => {

    }

    const onChangeCheckbox = (documentId: string, isChecked: boolean) => {
        // handle checkbox change
        setSelectedDocuments((prevSelected) => {
            if (isChecked) {
                return [...prevSelected, documentId];
            } else {
                return prevSelected.filter((id) => id !== documentId);
            }
        });
    }

    const loadDocumentsForCustomer = async (customerId: string) => {
        setDocumentsList([]);
        const documentsData: any = await customerCardModel.customerDocumentsFilter({ customerId: customerId });
        if (documentsData && documentsData.length > 0) {
            const documents = documentsData.sort((a: any, b: any) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime());
            setDocumentsList(documents);
        }
    }

    const importFile = async () => {
        if (selectedDocuments.length === 0) {
            alert('Please select at least one document to import.');
            return;
        }

        let choosenFiles: any[] = [];
        documentsList.forEach((doc) => {
            if (selectedDocuments.includes(doc.id)) {
                choosenFiles.push(doc);
            }
        });

        console.log('importFile-choosenFiles', choosenFiles)

        // proceed with import logic
        console.log('importFile documents: ', selectedDocuments);
    }

    return (
        <div className='wrapper-pop-up'>
            <div className='header-pop-up'>
                <div className='title-pop-up'>{"יבוא מסמכים"}</div>
                <div className='close-pop-up-button'>X</div>
            </div>

            <div className='body-pop-up'>
                <div className='customer-selection'>
                    <label className='customer-selection-label'> {"בחירת לקוח"}</label>
                    <div className="customer-selection-wrapper">
                        <input
                            type="text"
                            className="customer-selection-select customer-selection-autocomplete-input"
                            placeholder="הקלד שם ..."
                            value={
                                customerSearch ||
                                (customersList.find((c) => c.value === customerChosen) ? customersList.find((c) => c.value === customerChosen).label + '-' + customersList.find((c) => c.value === customerChosen).identifier : '')
                            }
                            onChange={(e) => {
                                setCustomerSearch(e.target.value);
                                setIsCustomerListOpen(true);
                            }}
                            onFocus={() => setIsCustomerListOpen(true)}
                            onBlur={() => {
                                // small delay so click on item will still fire
                                setTimeout(() => setIsCustomerListOpen(false), 150);
                            }}
                        />

                        {isCustomerListOpen && filteredCustomers.length > 0 && (
                            <ul className="customer-selection-autocomplete-list">
                                {filteredCustomers.map((client) => (
                                    <li
                                        key={client.value}
                                        className="customer-selection-autocomplete-item"
                                        onMouseDown={() => {
                                            // onMouseDown so it fires before input blur
                                            setCustomerChosen(client.value);
                                            setCustomerSearch(client.label);
                                            setIsCustomerListOpen(false);
                                            loadDocumentsForCustomer(client.value);
                                        }}
                                    >
                                        {client.label}-{client.identifier}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>


                </div>

                <div className='documents-selection'>
                    <label className='documents-selection-label'>{"בחירת מסמכים ליבוא"}</label>
                    <div className='documents-list'>
                        {documentsList.length === 0 && <div className='no-documents-label'>No documents found for this customer.</div>}
                        {documentsList.map((doc: any) => (
                            <div key={doc.id} className='document-item'>
                                <input type="checkbox" id={doc.id} name={doc.name} value={doc.id}
                                onChange={
                                    (e) => {
                                        // handle document selection
                                        onChangeCheckbox(doc.id, e.target.checked);
                                    }
                                } />
                                <label htmlFor={doc.id} className='document-name-label'>{doc.name}</label>
                            </div>
                        ))}
                    </div>


                </div>
            </div>



            <div className='footer-pop-up'>
                <button className='btn-secondary-pop-up'>Cancel</button>
                <button className='btn-primary-pop-up' onClick={importFile}>Import</button>
            </div>


        </div>
    )
}

export default ImportDocumentsPopUp